import { ReactElement } from 'react';
import cn from 'classnames';
import styles from './badge.module.sass';

interface IBadge {
    children: string | number | ReactElement;
    position?: 'bottom' | 'top';
    /**
     * For indicating that program is live
     */
    live?: boolean;
    /**
     * Light bg; dark text
     */
    secondary?: boolean;
    /**
     * 50% border-radius. Used to create round badge
     */
    fullRadius?: boolean;
    className?: string;
    isSmall?: boolean;
    sticky?: boolean;
    tag?: boolean;
}

/**
 * Badge used to indicate if program is `live`, or if it's `rewind` or coming up `next`
 */
export const Badge = ({
    children,
    live,
    secondary,
    fullRadius,
    className = '',
    isSmall,
    sticky,
    tag,
    position = 'top',
}: IBadge) => {
    const classNames = cn(
        styles.badge,
        styles[position],
        // TODO: check why `live` is used twice
        {
            [styles.live]: live,
            [styles.tag]: tag,
            [styles.secondary]: secondary,
            'badge-live': live,
            [styles['full-radius']]: fullRadius,
            [styles.small]: isSmall,
            [styles.sticky]: sticky,
        },
        className
    );

    return (
        <span className={classNames}>
            <span className={styles.text} title={typeof children === 'string' ? children : ''}>
                {children}
            </span>
        </span>
    );
};
